import {React, useContext} from "react";
import axios from "axios";
import "./BannerPics.scss";
import {prefixUrl} from "../../Utils/utilsData";
import {toast} from "react-toastify";
import {SetSaleContext} from "../pages/Pages";
import {useNavigate} from "react-router-dom";

const BannerPics = ({data}) => {

  const navigateTo = useNavigate();

  const bannerClickHandler = (data) => {
    navigateTo("/DetailBlog/" + data.id);
  }

  return (
    <>
      <div className="banner_pics">
        <div className="banner_pics_right_">
          <div className="banner_pics_right_top">
            <div className="banner_pics_right_side_title">
              <div className="titlePrent__">
                <h3>Food shopping cart</h3>
                <div className="title__box">سبد خرید غذاها</div>
              </div>
              {/* <div className="linkViewAllPrnt__">
                <Link to={data.urlTitle} className="linkViewAll__">
                  مشاهده همه
                  <IconViewer icon={'ArrowSquareLeft'}/>
                </Link>
              </div> */}
            </div>
            <div className="banner_pics_right_side image-parent">
              <div className="image-inner" onClick={() => bannerClickHandler(data[0])}>
                <img src={data[0]?.image} alt=""/>
              </div>
            </div>
          </div>
        
          <div className="banner_pics_right_bottom">
            <div className="banner_pics_right_side image-parent">
              <div className="image-inner" onClick={() => bannerClickHandler(data[1])}>
                <img src={data[1]?.image} alt=""/>
              </div>
            </div>
            <div className="banner_pics_right_side image-parent">
              <div className="image-inner" onClick={() => bannerClickHandler(data[2])}>
                <img src={data[2]?.image} alt=""/>
              </div>
            </div>
          </div>
        </div>
        <div className="banner_pics_left_ image-parent">
          <div className="image-inner" onClick={() => bannerClickHandler(data[3])}>
            <img src={data[3]?.image} alt=""/>
          </div>
        </div>
      </div>
      {/* responive banners added */}
      {/* <div className="banner_pics_responsive">
        <div className="banner_pics_right_top_responsive">
          <div className="banner_pics_right_side_title_responsive">
            <div className="titlePrent___responsive">
              <h3>{data.englishTitle}</h3>
              <Link to={data.urlTitle} className="title__box_responsive">
                {data?.title}
              </Link>
            </div>
            <div className="linkViewAllPrnt___responsive">
              <Link to={data.urlTitle} className="linkViewAll___responsive">
                مشاهده همه
                <IconViewer icon={"ArrowSquareLeft"} />
              </Link>
            </div>
          </div>
          <Link to={data.imgs[0].url} style={{ width: "48%", height: "100%" }}>
            <div className="banner_pics_right_side_responsive">
              <img src={data.imgs[0].src} alt="" />
            </div>
          </Link>
        </div>
        <Link to={data.imgs[1].url} style={{ width: "100%", height: "100%" }}>
          <div className="banner_pic_middle_responsive">
            <img src={data.imgs[1].src} alt="" />
          </div>
        </Link>
        <div className="banner_pics_bottom_responsive">
          <Link to={data.imgs[2].url} style={{ width: "48%", height: "100%" }}>
            <div className="banner_pics_side_bottom_responsive">
              <img src={data.imgs[2].src} alt="" />
            </div>
          </Link>
          <Link to={data.imgs[3].url} style={{ width: "48%", height: "100%" }}>
            <div className="banner_pics_side_bottom_responsive">
              <img src={data.imgs[3].src} alt="" />
            </div>
          </Link>
        </div>
      </div> */}
      {/* end of responsive */}
    </>
  );
};

export default BannerPics;
